module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_1_1-025dc857a4d820ec9d906721ff123615.webp";